import { Component, OnInit } from '@angular/core';
import { AltitudeFilterService } from 'src/app/services/altitude-filter.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { PointsService } from 'src/app/services/points.service';
import { Feature } from 'ol';
import { CalculationsService } from 'src/app/services/calculations.service';
import { TabsService } from 'src/app/services/tabsService';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { CoordinatePointsFilterService } from 'src/app/services/coordinate-points-filter.service';
import { CalculationModel } from 'src/app/models/calculations';
import { FilterModel } from 'src/app/models/filter';
import { UiBlockService } from 'src/app/services/ui-block.service';

@Component({
  selector: 'app-altitude-filter',
  templateUrl: './altitude-filter.component.html',
  styleUrls: ['./altitude-filter.component.scss'],
  standalone: false
})
export class AltitudeFilterComponent implements OnInit {
  private readonly coordinatePointAltitudeFilterField: string = 'Altitude';

  minAltitudeRange : number = 0;
  maxAltitudeRange : number = 60000;

  checkboxCoverage : boolean = true;
  checkboxImpact : boolean = true;

  checkboxCumulativeCoverage : boolean = true;
  checkboxPerformance : boolean = true;
  checkboxNavaidSitingTool : boolean = true;
  checkboxPerformanceAnalysis : boolean = true;
  checkboxCoordiantePoints : boolean = true;

  constructor(
    public altitudeFilterController : AltitudeFilterService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    private pointsController : PointsService,
    private calculationController : CalculationsService,
    public tabsService: TabsService,
    public coordinatePointsService: CoordinatePointsService,
    private coordinatePointsFilterService: CoordinatePointsFilterService,
    private uiBlock: UiBlockService,
    ) { }

  ngOnInit(): void {
  }

  cancelWindow():void{
    this.altitudeFilterController.active = !this.altitudeFilterController.active;
    this.toolsService.navigationOnTop = false;
  }
  isOutsideFilterRange(feat: Feature, minAltitudeRange: number, maxAltitudeRange: number) {
    return !(feat.getProperties().ELEVATION >= minAltitudeRange && feat.getProperties().ELEVATION <= maxAltitudeRange)
  }
  async applyFilter(): Promise<void> {
    this.uiBlock.startBlock("Applying Filter...");
    try {
      // this.pointsController.clearSelectedCoordinatePoints();
      if (this.checkboxCoordiantePoints) {
        this.syncCoordinatePointAltitudeFilter();
        if (this.areCoordinatePointsVisibleInViewMenu()) {
          await this.pointsController.fetchAndAddCoordinatePoints();
        }
      }

      if(this.checkboxCoverage){
        this.pointsController.getCalculationsLayer().childLayers.forEach( layer => {
          let calculationFeats : Feature[] = [];
          if(layer.type == 'Coverage'){
            this.pointsController.getAllCalculationFeaturesFromLayer(layer).forEach( feat => {
              if(!(feat.getProperties().ELEV >= this.minAltitudeRange && feat.getProperties().ELEV <= this.maxAltitudeRange)){
                calculationFeats.push(feat);
              }
            });
            this.pointsController.removeCalculationFeaturesFromLayer(calculationFeats, layer.layers[0]);
          }
        });
      }

      if(this.checkboxImpact){
        this.pointsController.getCalculationsLayer().childLayers.forEach( layer => {
          let calculationFeats : Feature[] = [];
          if(layer.type == 'Impact Assessment'){
            this.pointsController.getAllCalculationFeaturesFromLayer(layer).forEach( feat => {
              if(!(feat.getProperties().ELEV >= this.minAltitudeRange && feat.getProperties().ELEV <= this.maxAltitudeRange)){
                calculationFeats.push(feat);
              }
            });
            this.pointsController.removeCalculationFeaturesFromLayer(calculationFeats, layer.layers[0]);
          }
        });
      }

      if(this.checkboxPerformance){
        this.pointsController.getCalculationsLayer().childLayers.forEach( layer => {
          let calculationFeats : Feature[] = [];
          if(layer.type == 'Performance'){
            this.pointsController.getAllCalculationFeaturesFromLayer(layer).forEach( feat => {
              if(!(feat.getProperties().ELEVATION >= this.minAltitudeRange && feat.getProperties().ELEVATION <= this.maxAltitudeRange)){
                calculationFeats.push(feat);
              }
            });
            this.pointsController.removePerformanceCalculationFeaturesFromLayer(calculationFeats, layer);
          }
        });
      }

      if(this.checkboxCumulativeCoverage){
        this.pointsController.getCalculationsLayer().childLayers.forEach( layer => {
          let calculationFeats : Feature[] = [];
          if(layer.type == 'Cumulative Coverage'){
            this.pointsController.getAllCalculationFeaturesFromLayer(layer).forEach( feat => {
              if(!(feat.getProperties().ELEVATION >= this.minAltitudeRange && feat.getProperties().ELEVATION <= this.maxAltitudeRange)){
                calculationFeats.push(feat);
              }
            });
            this.pointsController.removeCalculationFeaturesFromLayer(calculationFeats, layer.layers[0]);
          }
        });
      }

      //TODO: NAVAID SITING TOOL
      if (this.checkboxNavaidSitingTool){
        this.pointsController.getCalculationsLayer().childLayers.forEach( layer => {
          let calculationFeats : Feature[] = [];
          if(layer.type == 'NavaidSitingTool'){
            this.pointsController.getAllCalculationFeaturesFromLayer(layer).forEach( feat => {
              if(!(feat.getProperties().elevationFT >= this.minAltitudeRange && feat.getProperties().elevationFT <= this.maxAltitudeRange)){
                calculationFeats.push(feat);
              }
            });
            this.pointsController.removeCalculationFeaturesFromLayer(calculationFeats, layer.layers[0]);
          }
        });

      }

      if(this.checkboxPerformanceAnalysis){
        this.pointsController.getCalculationsLayer().childLayers.forEach(
          layer => {
            let calculationFeats : Feature[] = [];
            if(layer.type == 'PROCEDURE_ANALYSIS'){
              for(let layerOfType of layer.layers){
                calculationFeats = layerOfType.olLayer.getSource()
                .getFeatures().filter((feat) => this.isOutsideFilterRange(feat,this.minAltitudeRange,this.maxAltitudeRange))
                this.pointsController.removeCalculationFeaturesFromLayer(calculationFeats,layerOfType);
              }
            }
          }
        );
      }
    } finally {
      this.uiBlock.stopBlock();
    }
  }

  private syncCoordinatePointAltitudeFilter(): void {
    this.coordinatePointsFilterService.filters = this.coordinatePointsFilterService.filters
      .filter(filter => filter.field !== this.coordinatePointAltitudeFilterField);

    if (!this.checkboxCoordiantePoints) {
      return;
    }

    const parsedMinAltitude = Number(this.minAltitudeRange);
    const parsedMaxAltitude = Number(this.maxAltitudeRange);

    if (isNaN(parsedMinAltitude) || isNaN(parsedMaxAltitude)) {
      return;
    }

    const minAltitude = Math.min(parsedMinAltitude, parsedMaxAltitude);
    const maxAltitude = Math.max(parsedMinAltitude, parsedMaxAltitude);

    const filter: FilterModel = {
      field: this.coordinatePointAltitudeFilterField,
      value: minAltitude + ' - ' + maxAltitude + ' ft',
      airportPk: 0,
      isSelected: false,
      active: true,
      minAltitude,
      maxAltitude,
    };

    this.coordinatePointsFilterService.filters.push(filter);
  }

  private areCoordinatePointsVisibleInViewMenu(): boolean {
    const coordinatePointsLayer = this.pointsController.getCoordinatePointsLayer();

    if (!coordinatePointsLayer || !coordinatePointsLayer.childLayers) {
      return false;
    }

    return coordinatePointsLayer.childLayers.some(topLayer =>
      topLayer.layers?.some(layer => layer.visible || layer.olLayer?.getVisible())
    );
  }

  async resetFilter() {
    this.uiBlock.startBlock("Resetting Filter...");
    
    try{
      this.coordinatePointsFilterService.filters = this.coordinatePointsFilterService.filters
        .filter(filter => filter.field !== this.coordinatePointAltitudeFilterField);
      
      if (this.areCoordinatePointsVisibleInViewMenu()) {
        await this.pointsController.fetchAndAddCoordinatePoints();
      }


      this.pointsController.getCalculationsLayer().childLayers.forEach( layer => {
        layer.removeFromMap();
      });

      this.pointsController.calculationsLayers.childLayers = [];
      const calculations: CalculationModel[] = await this.calculationController.getPreviousCalculationsHttpRequest().toPromise() || [];
      this.calculationController.addCalculationsToMap(calculations);
    } finally {
      this.uiBlock.stopBlock();
    }
  }
}
